import { Suspense, useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import DeleteModel from "../../Components/DeleteModel";
import { deleteItem, submitForm, toggleStatus } from "../../utils/apiUtils";
import {
    ActionButton,
    PlusButton,
    SwitchToggle,
    ToggleSwitch,
} from "../../helper/ImageFormat";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import BackButton from "../../Components/BackButton";

const StichingOption = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(false);
    const [stitchingOptiondata, setstitchingOptiondata] = useState([]);
    const [editingId, setEditingId] = useState(null);
    const navigator = useNavigate();
    const [btnLoading, setBtnLoading] = useState(false);
    const [errors, setErrors] = useState({
        name: "",
        dispatch_time: "",
        price: 0,
        type: "",
        catalogue_price: 0,
    });
    const [data, setData] = useState({
        name: "",
        dispatch_time: "",
        price: 0,
        type: "",
        catalogue_price: 0,
        isActive: true
    });

    const [deleteItemId, setDeleteItemId] = useState({});
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const handleEditClick = (item) => {
        const { name, dispatch_time, price, type, catalogue_price, isActive } = item;
        setData({ name, dispatch_time, price, type, catalogue_price, isActive });
        setEditingId(item.id);
        setModalOpen(true);
    };

    const toggleModal = () => {
        setModalOpen(!modalOpen);
        setEditingId((previous) => null);
        setErrors({
            name: "",
            dispatch_time: "",
            price: 0,
            type: "",
        });
    };

    const fetchData = async () => {
        await fetchAllData(
            `/stitching-option/${id}`,
            setstitchingOptiondata,
            null,
            setLoading
        );
    };
    useEffect(() => {
        fetchData();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setData({ ...data, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBtnLoading(true);
        try {
            data.stitchingGroup_id = id;
            if (editingId) {
                delete data._count;
            }

            await submitForm({
                data,
                url: "/single-stitching-option",
                editingId,
                validateFields: [
                    { name: "name", message: "Name is required" },
                    { name: "type", message: "Type is required" },
                ],
                validationErrorsSetter: setErrors,
                onSuccess: () => fetchData(),
                closeModal: () => setModalOpen(false),
            });
        } catch (err) {
            return err
        }
        finally {
            setBtnLoading(false);

        }

    };

    const handleDelete = async (data) => {
        setDeleteItemId(data);
        setDeleteModalOpen(true);
    };

    const confirmDelete = async () => {
        setIsDeleting(true);
        try {
            const res = await deleteItem("stitching-option", deleteItemId?.id, fetchData);
            setDeleteItemId({});
            setDeleteModalOpen(false);
            return res;
        } catch (err) {
            throw err;
        } finally {
            setIsDeleting(false);
        }
    };

    const handleStatusToggle = async (item) => {
        const data = await toggleStatus("stitching-option-status", item?.id);
        if (Object.keys(data).length > 0) {
            setstitchingOptiondata((prevCurrencies) =>
                prevCurrencies.map((curr) =>
                    curr.id === item.id ? { ...curr, isActive: data?.isActive } : curr
                )
            );
        }
    };

    const Tableheader = [
        "Name",
        "Type",
        "Price",
        "Dispatch Days",
        "Measurements",
        "Is Active",
        "Action",
    ];

    const handleAddoption = () => {
        setData({ name: "", dispatch_time: "", price: 0, type: "" });
        setModalOpen(true);
    };

    const breadcrumbdata = [
        { label: "Home", path: "/" },
        { label: "Stitching", path: "/stitching" },
        { label: "Stitching-Options", path: "/stitching-option" },
    ];
    return (
        <>
            <div className="content-wrapper">
                <div
                    className="page-header mt-5"
                    style={{ display: "flex", justifyContent: "space-between" }}
                >
                    <h3 className="custom-page-title">Stitching Options</h3>
                    <Breadcrumb items={breadcrumbdata} />
                </div>

                <div
                    className="d-flex justify-content-end mb-2"
                    style={{ background: "#fff", padding: "10px", marginTop: "-20px" }}>
                  {/* <PerPageSelect value={perPage} onChange={setPerPage}/> */}
                    <div style={{ display: "flex", gap: "20px" }}>
                        <BackButton/>
                    <PlusButton handleAdd={handleAddoption} module={"stitching option"} />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="pb-20 table-responsive">
                                    <table
                                        className=" custom-table table table-striped"
                                        id="stitchingTable"
                                    >
                                        <thead>
                                            <tr className="text-left">
                                                {Tableheader.map((item, index) => (
                                                    <th className="font-weight-bold col-1 text-left" key={index}> {item}</th>
                                                ))}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="12" className="text-center">
                                                        <Spinner />
                                                    </td>
                                                </tr>
                                            ) : stitchingOptiondata.length > 0 ? (
                                                stitchingOptiondata.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="text-left">{item?.name}</td>
                                                            <td className="text-left">{item?.type}</td>
                                                            <td className="text-left">{item?.price}</td>
                                                            <td className="text-left">{item?.dispatch_time}</td>
                                                            <td className="text-left">
                                                                {item._count?.stitchingValues !== undefined ? (
                                                                    <button
                                                                        type="button"
                                                                        className="count-button1"
                                                                        onClick={() => {
                                                                            navigator(`/stitching-measurement/${item?.id}`, {
                                                                                state: item,
                                                                            });
                                                                        }}
                                                                    >
                                                                        {item._count?.stitchingValues}
                                                                    </button>
                                                                ) : (
                                                                    <span>---</span>
                                                                )}
                                                            </td>

                                                            <td>
                                                                <ToggleSwitch
                                                                    data={item}
                                                                    name="isActive"
                                                                    checked={item.isActive}
                                                                    handleStatusToggle={handleStatusToggle}
                                                                    module={"stitching option"}
                                                                />
                                                            </td>
                                                            <td>
                                                                <ActionButton
                                                                    data={item}
                                                                    handleEditClick={handleEditClick}
                                                                    handleDelete={handleDelete}
                                                                    module={"stitching option"}
                                                                />
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan="12" className="text-center">
                                                        <h4> No data available</h4>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Suspense fallback={<p>Loading...</p>}>
                {modalOpen && (
                    <Modal
                        isOpen={modalOpen}
                        toggle={toggleModal}
                        centered
                        className="white-modal"
                    >
                        <ModalHeader toggle={toggleModal} className="close-currency">
                            {editingId ? "Update" : "Add"} Stitching Option
                        </ModalHeader>
                        <form onSubmit={handleSubmit}>
                            <ModalBody className="currency">
                                <div className="mb-3">
                                    <select
                                        className="form-control form-control-sm "
                                        id="type"
                                        name="type"
                                        defaultValue=""
                                        value={data?.type}
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled>
                                            Select Field Type
                                        </option>
                                        <option value="Redio">Radio</option>
                                        <option value="CheckBox">CheckBox</option>
                                    </select>
                                    {errors.type && <small className="text-danger">{errors.type}</small>}
                                </div>

                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm border border-dark"
                                        id="name"
                                        name="name"
                                        placeholder="Enter name"
                                        value={data.name}
                                        onChange={handleChange}
                                    />
                                    {errors.name && <small className="text-danger">{errors.name}</small>}
                                </div>

                                <div className="mb-3">
                                    <input
                                        type="number"
                                        className="form-control form-control-sm border border-dark"
                                        id="price"
                                        name="price"
                                        placeholder="Enter price"
                                        value={data.price}
                                        onChange={handleChange}
                                    />
                                    {errors.code && <small className="text-danger">{errors.code}</small>}
                                </div>
                                <div className="mb-3">
                                    <input
                                        type="number"
                                        className="form-control form-control-sm border border-dark"
                                        id="catalogue_price"
                                        name="catalogue_price"
                                        placeholder="Enter Price for catalogue"
                                        value={data.catalogue_price}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-3">
                                    <input
                                        type="text"
                                        className="form-control form-control-sm border border-dark"
                                        id="dispatch_time"
                                        name="dispatch_time"
                                        placeholder="Enter dispatch days"
                                        value={data.dispatch_time}
                                        onChange={handleChange}
                                    />
                                    {errors.dispatch_time && (
                                        <small className="text-danger">{errors.dispatch_time}</small>
                                    )}
                                </div>


                                <div className="col-md-12 mt-4 p-0" >
                                    <SwitchToggle
                                        checked={data.isActive}
                                        onChange={(val) => setData((prev) => ({ ...prev, isActive: val }))}
                                    />
                                </div>
                            </ModalBody>
                            <ModalFooter>
                                <Button color="primary" type="submit" disabled={btnLoading}>
                                    {btnLoading ? (
                                        <>
                                            <i className="fas fa-spinner fa-spin me-2" />
                                            {editingId ? "Updating..." : "Adding..."}
                                        </>
                                    ) : editingId ? (
                                        "Update"
                                    ) : (
                                        "Add"
                                    )}
                                </Button>
                                <Button color="danger" onClick={toggleModal}>
                                    Cancel
                                </Button>
                            </ModalFooter>
                        </form>
                    </Modal>
                )}
            </Suspense>

            {deleteModalOpen && (
                <Suspense fallback={<p>Loading...</p>}>
                    <DeleteModel
                        deleteModalOpen={deleteModalOpen}
                        setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
                        onConfirm={confirmDelete}
                        itemName="Stitching Option And His Measurement"
                        isDeleting={isDeleting}
                    />
                </Suspense>
            )}
        </>
    );
};

export default StichingOption;
